<template>
	<div class="bottom">
		<el-row class="public-width width-auto box">
			<el-col :md="18">
				<div class="msg-list">
					<p>电话：4009100100</p>
					<p>邮政编码：315000</p>
					<p> 单位地址：浙江省宁波市大榭开发区海光楼203-1室 </p>
					<p> 浙江岩亨信息技术有限公司 | 版权所有 Copyright ©2021  All Right Reserved</p>
					<P>
						<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602012810" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
							<img src="../assets/gongan.png" style="float:left;padding-top: 5px;" />
							<p style="float:left;">浙公网安备 33010602012810号</p >
						</a>
						|
						<a href="https://beian.miit.gov.cn" target="_blank" style="color: #c5c5c5;">浙ICP备20028336号</a>
					</P>
					<div style="width:300px;margin:0 auto; padding:20px 0;">
						
			    </div>
        </div>
      </el-col>

      <el-col :md="4">
        <div class="msg-list">
          <el-image :src="require('@/assets/image/qrcode.png')" class="wx-img"></el-image>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  methods: {
    toGoods: function (index) {
      this.$router.push({ name: "Describe", query: { index: index } });
    },
  },
};
</script>
<style lang="less" scoped>
.bottom {
  background-color: rgb(24, 24, 24);
  padding: 25px 0;
  .box{
    display: flex;
        align-items: center;
  }
}
.wx-img {
  width: 110px;
  height: 110px;
  border: 3px solid rgb(139, 139, 139);
}
.msg-list {
  text-align: left;
  h3 {
    color: rgb(197, 197, 197);
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  p {
    font-size: 14px;
    color: rgb(197, 197, 197);
    margin: 5px 0;
    cursor: pointer;
  }
}
.icp {
  color: rgb(148, 148, 148);
  font-size: 13px;
}
</style>